import $ from 'jquery';
import extensions from '../libs/jQuery';

$.fn.extend(extensions);